import { render } from "./ReportAutocomplete.vue?vue&type=template&id=5f11b8b2"
import script from "./ReportAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReportAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__